import * as React from 'react';
import { Product } from '~/Api/Product';
import { SkMaxPrice } from '~/Api/User/ProductGroup/SkMaxPrice';

export const ProductProvider: React.FunctionComponent<
	React.PropsWithChildren<{
		skMaxPrice: SkMaxPrice | null;
		id: string;
		children(product: Product | null): React.ReactNode;
	}>
> = ({ skMaxPrice, id, children }) => {
	const product = React.useMemo(
		() => skMaxPrice?.products.find((candidate) => candidate.product.id === id)?.product ?? null,
		[skMaxPrice, id]
	);
	return <>{children(product)}</>;
};

ProductProvider.displayName = 'SkMaxPrice.ProductProvider';
